import ModuleList from "./List";
function Modules() {
  return (
    <div className="flex-fill">
      <ModuleList />
    </div>
  );
}
export default Modules;
